import { axiosIntance } from '../../config/AxiosConfig';

export const DashboardDao = {
  get: (accountId: string) => {
    return axiosIntance.get(`orders/dashboard?account=${accountId}`);
  }
};
